module.exports = __webpack_public_path__ + "public/img/gongxu_2.75b005d2.png";